import { ChangeDetectorRef, Component, Inject, inject, OnDestroy, OnInit, PLATFORM_ID, ViewChild } from "@angular/core";
import { isPlatformBrowser } from "@angular/common";
import { TranslateService } from "@ngx-translate/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Product } from "../../../Models/product";
import { CategoryService } from "../../../Services/category.service";
import { Category } from "../../../Models/category";
import { AccountService } from "../../../Services/account.service";
import { CartService } from "../../../Services/cart.service";
import { CartOffLineService } from "../../../Services/cartOffline.service";
import { CartProduct } from "../../../Models/cart-product";
import { Discount } from "../../../Models/discount";
import { ProductConfiguration } from "../../../Models/product-configuration";
import { InputQuantityComponent } from "../../../Global/input-quantity/input-quantity.component";
import { Client } from "../../../Models/client";
import { ProjectTheme } from "src/app/Models/ProjectTheme";
import { ProductConfigurationService } from "../../../Services/product-configuration.service";
import { MensualPipe } from "../../../shared/pipes/mensual.pipe";
import { SnackBarService } from "../../../Services/snackBar.service";
import { take } from "rxjs";
import { SeoService, SITE_NAME } from "../../../Services/seo.service";
import { TimedSnackbar } from "src/app/shared/utils/timed-snackbar";
import { homeCrumb } from "src/app/shared/utils/breadcrumb";
import { FavoriteService } from "src/app/Services/favorite.service";

/**
 * Interface representing a local cart structure.
 * @interface cartLocal
 */
export interface cartLocal {
  /** Unique identifier for the cart */
  idCart?: number;
  /** Array of cart products */
  CartProduct?: CartProduct[];
}

@Component({
  selector: "app-detail-page",
  templateUrl: "./detail-page.component.html",
  styleUrls: ["./detail-page.component.scss"],
  standalone: false
})
export class DetailPageComponent implements OnInit, OnDestroy {
  items: { label: string; url?: string }[] = [];
  bank: ProjectTheme = "WUnivers";
  baseColor: "" | "green-500" | "blue-500" = "blue-500";
  id!: number;
  brand: string = "";
  /** Product reference code */
  reference: string = "";
  selectedConfiguration: ProductConfiguration | null = null;
  /** Index of the selected configuration */
  selectedConfigurationIndex: number = 0;
  /** Available configurations for the product */
  configurations: any[] = [];
  /** Product name */
  productName: string = "";
  /** Total price of the product */
  totalPrice: string = "";
  /** Array of product characteristic values */
  info: string[] = [];
  /** Product state */
  availability: "EN_STOCK" | "RUPTURE_DE_STOCK" | "SUR_COMMANDE" | "OBSOLETE" =
    "EN_STOCK";
  /** Fallback image shown whenever a product has no reachable image */
  readonly DEFAULT_PRODUCT_IMAGE = "assets/images/logo_placeholder.png";
  /** Array of image URLs for the product */
  Imagesurl: string[] = [];
  /** Product description */
  productDescriptionprod: string = "";
  /** List of related products, shaped to match admin-common's ProductModel */
  productsList: any[] = [];
  /** Selected number of months for payment */
  selectedMonths: number = 36;
  /** Available payment month options */
  monthsPerStep: number[] = [12, 24, 36, 48, 60];
  /** Total amount for the product */
  totalAmount!: number;

  /**
   * product charactiriqtics (specs)
   */
  productCharacteristics: any;
  /** Button style */
  button:
    | "Primary"
    | "Secondary"
    | "Alert"
    | "Success"
    | "Disable"
    | "Black"
    | "Gost"
    | "Delete" = "Primary";
  /** Button label translation key */
  buttonLabel: string = "productsPage.details.addToCart";
  /** Flag to disable the button */
  disabled: boolean = false;
  /** Quantity value for the product */
  value: number = 1;
  /** Flag to disable quantity incrementor */
  disabledIncrementor: boolean = false;
  /** Translation key of the related products section title */
  titleprod: string = "productsPage.details.relatedProducts";
  /** URL for store locations */
  nosMgasinsUrl: string = "#/ourStores";
  /** Product specifications */
  specs: { label: string; value: string }[] = [];
  /** Base color for slider */
  baseColorslider: string = "blue-500";
  /** Quantity for popup display */
  popQuantity: number = 1;
  loading: boolean = false;
  /** Flag to show popup */
  showPopup: boolean = false;
  /** Selected product configuration */
  selectedproduct?: ProductConfiguration | null;
  max = 0;
  isProductActive: boolean = true;

  product?: Product;
  productDiscount?: Discount;
  prod?: CartProduct;

  private readonly translate = inject(TranslateService);
  readonly favoriteService = inject(FavoriteService);

  /** Page-local snackbar (stock and cart messages) */
  readonly snackbar = new TimedSnackbar(this.translate);

  showFixedHeader = false;
  showTabOnFixedHeader = false;
  mobile = false;
  quantity = 1;
  categoryId?: number;
  productId: number | null = null;
  configurationId?: number;
  loadingAddCart = false;
  url?: string;
  client: Client | null = null;
  storesPageUrl: string = "/stores";

  get isButtonsDisabled(): boolean {
    return ["RUPTURE_DE_STOCK", "SUR_COMMANDE", "OBSOLETE"].includes(
      this.availability,
    );
  }

  get monthlyAmount(): number {
    return Math.round(
      this.mensualPipe.transform(Number(this.totalPrice) || 0, this.selectedMonths),
    );
  }

  selectedCategoryLabel?: string;
  isDisabled?: boolean;

  /** Whether a client account is logged in: the buy-now button is only shown to guests */
  get isConnected(): boolean {
    return !!this.accountService.accountSubject.value;
  }

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private route: ActivatedRoute,
    private router: Router,
    private categoryService: CategoryService,
    private accountService: AccountService,
    private cartService: CartService,
    private cartOffLineService: CartOffLineService,
    private productConfigurationService: ProductConfigurationService,
    private mensualPipe: MensualPipe,
    private cdr: ChangeDetectorRef,
    private seoService: SeoService,
  ) { }

  ngOnInit(): void {
    this.route.data.subscribe((data: any) => {
      this.product = data.detail;
      this.isProductActive = this.product?.activate ?? false;
      //check if the product is active, otherwise redirect to not found page
      if (!this.isProductActive) {
        this.router.navigate(["/not-found"]);
        return;
      }
      this.id =
        this.product?.configurations[this.selectedConfigurationIndex].id || 0;
      this.brand = this.product?.brand?.name || "";
      this.configurations = this.product?.configurations || [];
      this.selectedConfiguration =
        this.product?.configurations[this.selectedConfigurationIndex] || null;
      this.reference =
        "  " +
        this.product?.configurations[this.selectedConfigurationIndex]
          ?.reference || "";
      this.productName =
        this.product?.configurations[this.selectedConfigurationIndex]?.name ||
        "";
      this.max =
        this.product?.configurations[this.selectedConfigurationIndex]
          ?.quantity || 1;
      this.editDescription(this.selectedConfigurationIndex);
      this.totalPrice =
        this.product?.configurations[this.selectedConfigurationIndex]?.price !==
          undefined &&
          this.product?.configurations[this.selectedConfigurationIndex]?.price !==
          null
          ? String(
            this.product.configurations[this.selectedConfigurationIndex]
              .price,
          )
          : "0"; // Ensure default value
      this.info =
        this.product?.configurations[
          this.selectedConfigurationIndex
        ]?.productCharacteristics
          ?.map((pc) => pc.value)
          .filter((v): v is string => v !== undefined) || [];
      const state =
        this.product?.configurations[this.selectedConfigurationIndex]?.state;
      if (
        state === "EN_STOCK" ||
        state === "RUPTURE_DE_STOCK" ||
        state === "SUR_COMMANDE" ||
        state === "OBSOLETE"
      ) {
        this.availability = state;
      } else {
        this.availability = "EN_STOCK";
      }
      const configImages =
        this.product?.configurations?.[this.selectedConfigurationIndex]
          ?.images;
      this.Imagesurl = configImages?.length
        ? configImages.map((img) => img.url || this.DEFAULT_PRODUCT_IMAGE)
        : [this.DEFAULT_PRODUCT_IMAGE];
      this.verifyImageUrls(this.Imagesurl);
      this.setSeo();
      this.cdr.detectChanges(); // Force change detection after synchronous updates

      this.productCharacteristics =
        this.product?.configurations[
          this.selectedConfigurationIndex
        ]?.productCharacteristics;
      //set product specs
      this.setProductSpecs(this.productCharacteristics);

      this.categoryService.getAllActivated().subscribe({
        next: (categories: Category[]) => {
          if (categories.length) {
            this.updateBreadCrumbs(categories);
            this.seoService.setBreadcrumbs(this.items);
          } else {
            this.items = [
              homeCrumb(this.translate),
              ...(this.product?.configurations[this.selectedConfigurationIndex]
                ?.name && !this.mobile
                ? [
                  {
                    label:
                      this.product.configurations[
                        this.selectedConfigurationIndex
                      ].name || "",
                    url: "./",
                  },
                ]
                : []),
            ].reverse();
          }
          this.cdr.detectChanges(); // Force change detection after breadcrumb update
        },
        error: (err) => {
          console.error("Error fetching categories:", err);
          this.items = [
            homeCrumb(this.translate),
            ...(this.product?.configurations[this.selectedConfigurationIndex]
              ?.name && !this.mobile
              ? [
                {
                  label:
                    this.product.configurations[
                      this.selectedConfigurationIndex
                    ].name || "",
                  url: "./",
                },
              ]
              : []),
          ].reverse();
          this.cdr.detectChanges();
        },
      });
    });

    if (this.product?.categoryId) {
      this.productConfigurationService
        .relatedConfigurations(this.product.categoryId, 0, 4)
        .subscribe({
          next: (configs) => {
            // lib-product-slider-setycore expects items shaped like admin-common's
            // ProductModel (images, designation, salePrice, pricePerMonth, ...).
            this.productsList = configs.map((conf: any) => ({
              productId: conf.id,
              images: [conf.images?.[0]?.url || this.DEFAULT_PRODUCT_IMAGE],
              designation: conf.name || conf.productName || "",
              description: this.stripHtml(conf.description),
              reference: conf.reference || "",
              brand: conf.productBrand || "",
              category: conf.categoryLabel || "",
              quantity: conf.quantity ?? 0,
              stockStatus: conf.state || null,
              salePrice: conf.price || null,
              pricePerMonth: Math.round(
                this.mensualPipe.transform(conf.price, 60),
              ),
            }));
            this.verifyProductImages(this.productsList);
            this.cdr.detectChanges();
          },
          error: (err) => {
            this.productsList = [];
            this.cdr.detectChanges();
          },
        });
    }
  }

  /**
   * The related-products card renders `description` via text interpolation
   * (not [innerHTML]), but the value is HTML authored via the admin WYSIWYG
   * editor. Strip the markup here so raw tags don't show up in the card.
   */
  private stripHtml(html?: string): string {
    if (!html) {
      return "";
    }
    return html.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
  }

  /**
   * Updates the selected quantity.
   * @method getQuantity
   * @param quantity - Selected quantity
   */
  getQuantity(quantity: number): void {
    this.quantity = quantity;
  }

  /**
   * Updates the number of months selected for the financing simulation.
   * @method onMonthChange
   * @param months - Newly selected number of months
   */
  onMonthChange(months: number): void {
    this.selectedMonths = months;
  }

  /**
   * Resets the add-to-cart popup so the user can keep browsing.
   * @method onContinueShopping
   */
  onContinueShopping(): void {
    this.showPopup = false;
  }

  /**
   * Navigates to the product list filtered by the clicked brand.
   * @method onBrandSelected
   */
  onBrandSelected(brand: string): void {
    const brandId = this.product?.brand?.id;
    if (!brandId) return;
    this.router.navigate(["/products"], {
      queryParams: { brands: brandId, inStock: true },
    });
  }

  /** Adds/removes the clicked related configuration from the favorites (`productId` = configuration id) */
  onToggleWishlist(configurationId: number): void {
    this.favoriteService.toggle(configurationId).subscribe();
  }

  /**
   * Handles selection of a related configuration and navigates to its detail page.
   * @method onRlatedConfigSelect
   * @param id - ID of the related configuration
   */
  onRlatedConfigSelect(id: number) {
    this.productConfigurationService.getByConfigurationId(id).subscribe({
      next: (configuration: ProductConfiguration) => {
        this.selectedproduct = configuration;
        this.cdr.detectChanges();
        const safeName = this.product?.name?.replace(/\//g, "-");
        this.router.navigate([
          `/products/${safeName}/${this.selectedproduct.productId}/${id}`,
        ]);
      },
      error: (err) => { },
    });
  }

  /**
   * Updates the popup visibility state.
   * @method onShowPopupChange
   * @param showPopup - Boolean to show or hide the popup
   */
  onShowPopupChange(showPopup: boolean) {
    this.showPopup = showPopup;
  }

  /**
   * Navigates to the cart page.
   * @method onSeeCart
   */
  onSeeCart() {
    this.router.navigate([`/cart`]);
  }

  /**
   * Updates the breadcrumb navigation based on product category.
   * @method updateBreadCrumbs
   * @param categories - List of available categories
   */
  updateBreadCrumbs(categories: Category[]) {
    this.items = [];

    const formatLabelForUrl = (label: string) =>
      label.replace(/[^a-zA-Z0-9]/g, "-");

    if (
      !this.mobile &&
      this.product?.configurations[this.selectedConfigurationIndex]?.name
    ) {
      this.items.push({
        label:
          this.product.configurations[this.selectedConfigurationIndex].name ||
          "",
        url: "./",
      });
    }

    let categoryId: any = this.product?.categoryId;
    if (!categoryId || !categories.length) {
      console.warn("No categoryId or categories, adding Home link");
      this.items.push(homeCrumb(this.translate, "/#/"));
      this.items.reverse();
      return;
    }

    let iterate = true;
    let subSubCategoryId: number | null = categoryId;
    let subCategoryId: number | null = null;
    let parentId: number | null = null;
    let parentLabel: string | null = null;

    while (iterate && categoryId) {
      const childCat = this.childCategory(categories, categoryId);
      if (!childCat) {
        console.warn("Category not found for ID:", categoryId);
        break;
      }

      const rootCategory = this.parentCategory(categories);
      this.selectedCategoryLabel = rootCategory?.label || "Root";
      const formattedRootLabel = formatLabelForUrl(this.selectedCategoryLabel);

      if (childCat.isVisible) {
        if (childCat.parentId) {
          const parentCat = this.childCategory(categories, childCat.parentId);
          if (parentCat?.parentId) {
            subSubCategoryId = childCat?.id || null;
            subCategoryId = parentCat?.id || null;
            parentId = parentCat.parentId;
            parentLabel =
              this.childCategory(categories, parentId)?.label ||
              this.selectedCategoryLabel;
            this.items.push({
              label: childCat.label,
              url: `/products/category/${parentId}/${formattedRootLabel}/${subCategoryId}/${formatLabelForUrl(
                parentCat.label,
              )}?categories=${subSubCategoryId}`,
            });
          } else {
            subCategoryId = childCat?.id || null;
            parentId = childCat.parentId;
            parentLabel =
              this.childCategory(categories, parentId)?.label ||
              this.selectedCategoryLabel;
            this.items.push({
              label: childCat.label,
              url: `/products/category/${parentId}/${formattedRootLabel}/${subCategoryId}/${formatLabelForUrl(
                childCat.label,
              )}`,
            });
          }
        } else {
          parentId = childCat?.id || null;
          parentLabel = childCat.label;
          this.items.push({
            label: childCat.label,
            url: `/products/category/${parentId}/${formatLabelForUrl(
              childCat.label,
            )}`,
          });
        }
      }

      categoryId = childCat.parentId;
      if (!categoryId) {
        iterate = false;
        this.items.push(homeCrumb(this.translate, "/#/"));
        this.items.reverse();
      }
    }
  }

  /**
   * Cleans and updates the product description by removing HTML tags.
   * @method editDescription
   * @param selectedConfiguration - Index of the selected configuration
   */
  editDescription(selectedConfiguration: number) {
    const config = this.product?.configurations?.[selectedConfiguration];
    if (config?.description) {
      // On ne fait plus de .replace(), on garde le HTML brut
      this.productDescriptionprod = config.description;
    }
  }

  /**
   * Sets the page title, description and preview image from the displayed product
   * @method setSeo
   */
  setSeo() {
    const config = this.product?.configurations?.[this.selectedConfigurationIndex];
    const name = this.productName || this.product?.name || "";
    const title = this.brand && !name.toLowerCase().includes(this.brand.toLowerCase())
      ? `${name} - ${this.brand}`
      : name;
    this.seoService.set({
      title,
      description:
        config?.description ||
        this.product?.description ||
        `Achetez ${name} en cash ou par facilités de paiement sur Wissal Univers, en ligne ou dans nos 5 showrooms en Algérie.`,
      image: this.Imagesurl[0] !== this.DEFAULT_PRODUCT_IMAGE ? this.Imagesurl[0] : undefined,
    });
    this.setProductJsonLd(name);
  }

  /**
   * Publishes the product as schema.org `Product` structured data, so search results can show its price and
   * availability
   * @method setProductJsonLd
   * @param name - Displayed product name
   */
  setProductJsonLd(name: string) {
    const config = this.product?.configurations?.[this.selectedConfigurationIndex];
    if (!config) {
      return;
    }
    const now = new Date();
    const discount = config.discount;
    const hasDiscount =
      !!discount &&
      discount.status !== false &&
      now >= new Date(discount.startingDate) &&
      now <= new Date(discount.endingDate);
    const price = (config.price ?? 0) * (hasDiscount ? 1 - discount!.value / 100 : 1);
    const availability: Record<string, string> = {
      EN_STOCK: "InStock",
      RUPTURE_DE_STOCK: "OutOfStock",
      SUR_COMMANDE: "BackOrder",
      BIENTOT_DISPONIBLE: "PreOrder",
      OBSOLETE: "Discontinued",
    };
    const images = this.Imagesurl.filter((url) => url !== this.DEFAULT_PRODUCT_IMAGE).map((url) =>
      this.seoService.absoluteUrl(url),
    );
    const description = (config.description || this.product?.description || "")
      .replace(/<[^>]*>/g, " ")
      .replace(/\s+/g, " ")
      .trim();
    const gtin = config.codEAN || this.product?.codeEAN;

    this.seoService.setJsonLd("product", {
      "@context": "https://schema.org",
      "@type": "Product",
      name,
      ...(images.length && { image: images }),
      ...(description && { description }),
      ...(config.reference && { sku: config.reference }),
      ...(config.refConstructor && { mpn: config.refConstructor }),
      ...(gtin && { gtin }),
      ...(this.brand && { brand: { "@type": "Brand", name: this.brand } }),
      ...(config.isUsed && {
        itemCondition: `https://schema.org/${config.isUsed === "NEUF_SOUS_EMBALLAGE" ? "NewCondition" : "UsedCondition"}`,
      }),
      offers: {
        "@type": "Offer",
        url: this.seoService.absoluteUrl("./"),
        priceCurrency: "DZD",
        price: price.toFixed(2),
        ...(hasDiscount && { priceValidUntil: discount!.endingDate.slice(0, 10) }),
        availability: `https://schema.org/${availability[config.state ?? ""] ?? "InStock"}`,
        seller: { "@type": "Organization", name: SITE_NAME },
      },
    });
  }

  ngOnDestroy(): void {
    this.seoService.removeJsonLd("product");
    this.seoService.removeJsonLd("breadcrumbs");
  }

  childCategory(
    categories: Category[],
    parentId: number,
  ): Category | undefined {
    return categories.find((category: Category) => category.id === parentId);
  }

  parentCategory(categories: Category[]): Category | undefined {
    return categories.find((category: Category) => category.parentId === null);
  }

  /**
   * @description set the product specs
   */
  setProductSpecs(productCharacteristics: any[]) {
    this.specs = productCharacteristics.map((item: any) => ({
      label: item.characteristic.name, // .name is more descriptive than .type
      value: item.value,
    }));
  }

  /**
   * Preloads each gallery image and falls back to DEFAULT_PRODUCT_IMAGE
   * if it fails to load (e.g. expired/forbidden S3 link), since the API
   * returning a URL doesn't guarantee that URL is actually reachable.
   */
  private verifyImageUrls(urls: string[]): void {
    // no Image on the server: the check runs again in the browser
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    urls.forEach((url, index) => {
      if (!url || url === this.DEFAULT_PRODUCT_IMAGE) return;
      const probe = new Image();
      probe.onerror = () => {
        urls[index] = this.DEFAULT_PRODUCT_IMAGE;
      };
      probe.src = url;
    });
  }

  /**
   * Same as verifyImageUrls, for the related-products list where each
   * item carries its image as `images[0]` (ProductModel shape).
   */
  private verifyProductImages(items: any[]): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    items
      .filter(
        (item) => item.images?.[0] && item.images[0] !== this.DEFAULT_PRODUCT_IMAGE,
      )
      .forEach((item) => {
        const probe = new Image();
        probe.onerror = () => {
          item.images[0] = this.DEFAULT_PRODUCT_IMAGE;
        };
        probe.src = item.images[0];
      });
  }

  /**
   * Adds the selected product configuration to the cart.
   * @method addToCart
   */
  addToCart() {
    this.loading = true;

    if (this.accountService.accountSubject.value && this.product) {
      // Online storage
      this.client = this.accountService.accountSubject.value;
      this.cartService
        .add(
          this.product?.configurations[this.selectedConfigurationIndex],
          this.quantity,
        )
        .subscribe({
          next: (response: any) => {
            if (response.cartProduct) {
              if (response.cartProduct.quantity) {
                this.showPopup = true;
                this.popQuantity = response.cartProduct.quantity;
                this.loading = false;
              } else {
                this.showPopup = true;
                this.popQuantity = this.quantity;
                this.loading = false;
              }
              if (response.quantityCapped) {
                this.snackbar.show(
                  "warning",
                  "productsPage.snackbar.quantityExceedsStock",
                  { quantity: this.selectedConfiguration?.quantity },
                );
              }
            } else {
              this.snackbar.show("success", "productsPage.snackbar.productAdded");
              this.loading = false;
            }
          },
          error: () => {
            this.snackbar.show("alert", "productsPage.snackbar.addToCartError");
            this.loading = false;
          },
        });
    } else {
      // Offline storage
      const config = this.product!.configurations[this.selectedConfigurationIndex];
      const cartProduct: CartProduct = {
        configuration: config,
        quantity: this.quantity,
        configurationId: config.id,
      };

      this.loading = true;

      this.cartOffLineService.addCarts(cartProduct).subscribe({
        next: (response) => {
          if (response.success) {
            // Get latest cart state
            this.cartOffLineService.cart
              .pipe(take(1))
              .subscribe((res: cartLocal) => {
                const item = res.CartProduct?.find(
                  (p: any) => p.configurationId === cartProduct.configurationId,
                );
                this.popQuantity = item?.quantity || this.quantity;
                this.showPopup = true;
                this.loading = false;
              });
          }
          if (response.quantityCapped) {
            this.snackbar.show(
              "warning",
              "productsPage.snackbar.quantityExceedsStock",
              { quantity: this.selectedConfiguration?.quantity },
            );
          }
        },
        error: () => {
          this.snackbar.show("alert", "productsPage.snackbar.addToCartError");
          this.loading = false;
        },
      });
    }
  }

  /**
   * Opens the buy-now page for the selected configuration and quantity.
   * @method onBuyNow
   */
  onBuyNow(): void {
    const { name, id, configurationId } = this.route.snapshot.params;
    // the displayed configuration, which is not always the one in the url
    const displayedConfigurationId = this.selectedConfiguration?.id ?? configurationId;
    this.router.navigate(["/products", name, id, displayedConfigurationId, "buy-now"], {
      queryParams: { quantity: this.quantity },
    });
  }
}
